import { render, staticRenderFns } from "./KartaServis.vue?vue&type=template&id=c081908e&scoped=true&"
import script from "./KartaServis.vue?vue&type=script&lang=js&"
export * from "./KartaServis.vue?vue&type=script&lang=js&"
import style0 from "./KartaServis.vue?vue&type=style&index=0&id=c081908e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c081908e",
  null
  
)

export default component.exports